<template>
  <el-row :gutter="20" class="my_cell">
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.my_cell {
  margin-top: 16px;
  padding: 0 16px;
  align-items: inherit;
}
</style>
